<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline" v-on:keypress.enter.prevent="searchPurchaseOrder">
                    <input class="form-control mr-sm-2"
                           type="search"
                           v-model="search.po_number"
                           placeholder="เลขที่ใบ PO"
                           aria-label="Search"/>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    &nbsp
                    <b-form-select v-model="search.status"
                                   :options="optionStatus">
                    </b-form-select>
                    &nbsp
                    &nbsp
                    <input class="form-control mr-sm-2"
                           type="search"
                           v-model="search.vendor"
                           placeholder="ค้นหาผู้จำหน่าย"
                           aria-label="Search"/>
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchPurchaseOrder"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <router-link to="purchase-form">
                        <button class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            สร้าง PO
                        </button>
                    </router-link>
                    &nbsp
                    <button type="button" class="btn btn-primary my-2 my-sm-0"
                            @click="printReportExcel">
                        <icon name="file-download"></icon>
                        พิมพ์รายงาน Excel
                    </button>
                    <!--<button type="button" class="btn btn-primary"-->
                    <!--:disabled="checkbox_id.length < 1"-->
                    <!--@click="printManyPurchaseTax">-->
                    <!--<icon name="print"></icon>-->
                    <!--พิมพ์ใบภาษี-->
                    <!--</button>-->
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <!--<th scope="col">-->
                    <!--<input type="checkbox" v-model="selectAll"/>-->
                    <!--</th>-->
                    <th scope="col">ลำดับ</th>
                    <th scope="col">เลขที่ใบ PO</th>
                    <th scope="col">วันที่ออกใบ PO</th>
                    <th scope="col">ผู้จัดทำใบ PO</th>
                    <th scope="col">ผู้อัพเดตรายการ PO</th>
                    <th scope="col">ยอดเงิน</th>
                    <th scope="col">ผู้จำหน่าย</th>
                    <th scope="col">ภาษี</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">พิมพ์ใบ PO</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in PurchaseList">
                    <!--<td><input type="checkbox"-->
                    <!--v-model="checkbox_id" :value="data.id"/></td>-->
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>{{ data.po_number }}</td>
                    <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        {{ data.user ? data.user.name : '-' }}
                    </td>
                    <td>
                        {{ data.user_update ? data.user_update.name : '-' }}
                    </td>
                    <td>{{ data.total | currency }}</td>
                    <td>
                        <template v-if="data.vendor">
                            {{ data.vendor.name }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.status_tax">
                            <a @click="showChangePurchaseTax(data.id)"
                               style="color: #00a699;text-decoration:underline">มีภาษี</a>
                        </template>
                        <template v-else>
                            <a @click="showChangePurchaseTax(data.id)"
                               style="color: red ; text-decoration:underline">ไม่มีภาษี</a>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.status==1 && data.print_status==1">
                            <a @click="editStatusPurchaseOrder(data.id)"
                               style="color: red; text-decoration: underline">
                                {{ data.status_name }}
                            </a>
                        </template>
                        <template v-else-if="data.status == 2 || data.status == 3">
                        <span style="color: green">
                            {{ data.status_name }}
                        </span>
                        </template>
                        <template v-else>
                        <span style="color: gray">
                            {{ data.status_name }}
                        </span>
                        </template>
                    </td>
                    <td>
                        <button type="button" @click="refreshPage(data.id)"
                                class="btn btn-primary">
                            พิมพ์
                        </button>
                    </td>
                    <td>
                        <a @click="editPurchaseOrder(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="PurchaseList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getPurchaseOrderPage">
            </vue-pagination>
        </div>
        <br>
        <b-modal hide-header hide-footer ref="approve">
            <div>
                <edit-purchase-order-modal @submit="updateStatusPO">
                </edit-purchase-order-modal>
            </div>
        </b-modal>
        <br>
        <b-modal centered hide-header hide-footer ref="change_tax">
            <div>
                <change-purchase-tax @submit="hideChangePurchaseTax">
                </change-purchase-tax>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ checkbox_id }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import EditPreOrderModal from "./EditPreOrderModal";
import EditPurchaseOrderModal from "./EditPurchaseOrderModal";
import VuePagination from "../../Pagination";
import {domain} from "../../../util/Constants";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import ChangePurchaseTax from "./ChangePurchaseTax";

export default {
    components: {
        ChangePurchaseTax,
        VuePagination,
        EditPurchaseOrderModal,
        EditPreOrderModal,
        DatePicker,
        Multiselect
    },
    name: "purchase-order-list",
    data() {
        return {
            dateFormat: 'D MMM YYYY',
            delete_id: "",
            event_submit: false,
            optionStatus: [
                {value: '', text: 'เลือกสถานะ'},
                {value: 1, text: 'รอการอนุมัติ'},
                {value: 2, text: 'อนุมัติแล้ว'}
            ],
            checkbox_id: [],
            select_all: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.domain = domain + '/purchase-order-pdf/';
        this.$store.dispatch('PurchaseOrder/setPurchaseOrder');
        this.$store.dispatch("PurchaseOrder/clearSearch")
    },
    computed: {
        ...mapState({
            PurchaseList: state => {
                return state.PurchaseOrder.table;
            },
            dataPaginate: state => {
                return state.PurchaseOrder.dataPaginate;
            },
            search: state => {
                return state.PurchaseOrder.search;
            }
        }),
        selectAll: {
            get: function () {
                return this.PurchaseList ? this.checkbox_id.length >= this.PurchaseList.length : false;
            },
            set: function (value) {
                if (value) {
                    this.select_all = true;
                    return this.$store.dispatch("PurchaseOrder/selectPurchaseOrderAll").then(po_id => {
                        this.checkbox_id = po_id;
                    })
                } else {
                    this.select_all = false;
                    this.checkbox_id = [];
                }
            }
        }
    },
    methods: {
        editPurchaseOrder(id) {
            let route = this.$router.resolve({
                name: "purchase-form",
                query: {id: window.btoa(id)}
            });
            window.open(route.href, '_blank');
        },
        editStatusPurchaseOrder(id) {
            this.$store.dispatch('PurchaseOrder/show', id).then(() => {
                this.$refs.approve.show();
            });
        },
        showChangePurchaseTax(id) {
            //console.log(id);
            this.$store.dispatch('PurchaseOrder/show', id).then(() => {
                this.$refs.change_tax.show();
            });
        },
        hideChangePurchaseTax() {
            this.$refs.change_tax.hide();
            this.$store.dispatch("PurchaseOrder/setPurchaseOrder");
        },
        updateStatusPO(submitData) {
            if (submitData == 'cancel') {
                this.$refs.approve.hide();
            } else {
                this.$store.dispatch('PurchaseOrder/update', {
                    id: submitData.id,
                    data: submitData
                }).then(() => {
                    this.$store.dispatch('PurchaseOrder/setPurchaseOrder');
                    this.$refs.approve.hide();
                })
            }
        },
        printReportExcel() {
            let data = {
                page: 1,
                po: this.search.po_number,
                date_start: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                date_end: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                vendor: this.search.vendor ? this.search.vendor : '',
                status: this.search.status ? this.search.status : '',
                excel: 'excel'
            }
            window.open(domain + '/purchase-order-search?page=' + data.page +
                '&po=' + data.po + '' +
                '&date_start=' + data.date_start + '' +
                '&date_end=' + data.date_end + '' +
                '&excel=' + data.excel + '' +
                '&status=' + data.status + '' +
                '&vendor=' + data.vendor)
        },
        searchPurchaseOrder(page) {
            this.event_submit = true;
            this.$store.dispatch('PurchaseOrder/search', {
                page: page,
                po: this.search.po_number,
                date_start: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                date_end: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                vendor: this.search.vendor ? this.search.vendor : '',
                excel: '',
                status: this.search.status ? this.search.status : ''
            })
        },
        getPurchaseOrderPage() {
            const page = this.dataPaginate.current_page;
            this.searchPurchaseOrder(page);
            // if(this.event_submit){
            //     this.$store.dispatch('PurchaseOrder/search',{
            //         page : page,
            //         po:this.search.po_number,
            //         date:this.search.date,
            //         vendor: ""
            //     })
            // }else{
            //     //paginate get data
            //     this.$store.dispatch('PurchaseOrder/setPurchaseOrder',page)
            // }
        },
        printManyPurchaseTax() {
            if (this.checkbox_id.length > 0) {
                const id = this.checkbox_id.toString();
                window.open(domain + '/tax-purchase-multiple-pdf?id=' + id,
                    '_blank');
            }
        },
        refreshPage(id) {
            window.open(this.domain + id);
            location.reload();
        }
    }
}
</script>

<style lang="scss" scoped>
.select {
    border: 0;
}
</style>
